import { useState, FormEvent } from "react";

const services = [
  "Balayage / Highlights",
  "Full Color",
  "Haircut & Blowout",
  "Keratin Treatment",
  "Extensions",
  "Bridal / Event Styling",
  "Scalp Treatment",
  "Men\'s Cut & Style",
];

const stylists = [
  "Any Available Stylist",
  "Isabelle Fontaine",
  "Margot Delacroix",
  "Sofia Ricci",
  "Elena Vasquez",
];

export default function QuickBooking() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const body = new URLSearchParams();
    data.forEach((val, key) => body.append(key, val.toString()));

    setLoading(true);
    try {
      await fetch("https://readdy.ai/api/form/d7dr00fsch5bvrijflvg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="w-full bg-[#1a1209] py-20 px-6" id="booking">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#C9A96E] text-xs font-semibold tracking-[0.3em] uppercase mb-3 block">Reserve Your Chair</span>
          <h2 className="text-white text-3xl md:text-5xl font-bold leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Book Your Appointment
          </h2>
          <p className="text-white/50 mt-4 text-sm max-w-lg mx-auto leading-relaxed">
            Reserve in seconds. Our team will confirm your appointment within 2 hours.
          </p>
        </div>

        {submitted ? (
          <div className="max-w-xl mx-auto text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 rounded-full bg-[#C9A96E]/20">
              <i className="ri-checkbox-circle-line text-3xl text-[#C9A96E]"></i>
            </div>
            <h3 className="text-white text-2xl font-bold mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>You\'re on the list!</h3>
            <p className="text-white/60 text-sm leading-relaxed">We\'ve received your request and will reach out shortly to confirm your appointment. See you soon!</p>
          </div>
        ) : (
          <form
            data-readdy-form
            id="quick-booking-form"
            onSubmit={handleSubmit}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
          >
            <div className="flex flex-col gap-2">
              <label className="text-white/60 text-xs tracking-widest uppercase">Your Name</label>
              <input
                name="name"
                required
                type="text"
                placeholder="First & Last Name"
                className="bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#C9A96E] transition-colors"
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-white/60 text-xs tracking-widest uppercase">Email</label>
              <input
                name="email"
                required
                type="email"
                placeholder="your@email.com"
                className="bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#C9A96E] transition-colors"
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-white/60 text-xs tracking-widest uppercase">Phone</label>
              <input
                name="phone"
                type="tel"
                placeholder="+1 (702) 000-0000"
                className="bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#C9A96E] transition-colors"
              />
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-white/60 text-xs tracking-widest uppercase">Service</label>
              <select
                name="service"
                required
                className="bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white text-sm focus:outline-none focus:border-[#C9A96E] transition-colors appearance-none cursor-pointer"
              >
                <option value="" className="bg-[#1a1209]">Select a Service</option>
                {services.map((s) => (
                  <option key={s} value={s} className="bg-[#1a1209]">{s}</option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-white/60 text-xs tracking-widest uppercase">Preferred Stylist</label>
              <select
                name="stylist"
                className="bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white text-sm focus:outline-none focus:border-[#C9A96E] transition-colors appearance-none cursor-pointer"
              >
                {stylists.map((s) => (
                  <option key={s} value={s} className="bg-[#1a1209]">{s}</option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-2">
              <label className="text-white/60 text-xs tracking-widest uppercase">Preferred Date</label>
              <input
                name="date"
                type="date"
                className="bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white text-sm focus:outline-none focus:border-[#C9A96E] transition-colors cursor-pointer"
              />
            </div>
            <div className="flex flex-col gap-2 md:col-span-2 lg:col-span-3">
              <label className="text-white/60 text-xs tracking-widest uppercase">Special Notes (optional)</label>
              <textarea
                name="notes"
                placeholder="Tell us about your hair goals, allergies, or anything we should know..."
                rows={3}
                maxLength={500}
                className="bg-white/5 border border-white/10 rounded-sm px-4 py-3 text-white text-sm placeholder-white/30 focus:outline-none focus:border-[#C9A96E] transition-colors resize-none"
              />
            </div>
            <div className="md:col-span-2 lg:col-span-3 flex justify-center pt-2">
              <button
                type="submit"
                disabled={loading}
                className="bg-[#C9A96E] text-white text-sm font-semibold tracking-widest uppercase px-16 py-4 rounded-sm hover:bg-[#b8934f] transition-colors duration-200 whitespace-nowrap cursor-pointer disabled:opacity-60"
              >
                {loading ? "Sending..." : "Request Appointment"}
              </button>
            </div>
          </form>
        )}
      </div>
    </section>
  );
}
